import { render } from "./addActiveSale.vue?vue&type=template&id=f3edda76&scoped=true"
import script from "./addActiveSale.vue?vue&type=script&lang=js"
export * from "./addActiveSale.vue?vue&type=script&lang=js"

import "./addActiveSale.vue?vue&type=style&index=0&id=f3edda76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3edda76"]])

export default __exports__